export default "__VITE_ASSET__D5vJb4au__"